<template>
  <div id="tosf-hei-profile">
    <div class="mb-2">
      <a href="#" @click.prevent="$router.go(-1)" class="">
        <i class="bi bi-arrow-left-short icon-sm"></i> Go back
      </a>
    </div>

    <nav class="navbar navbar-expand-lg rounded navbar-light bg-white shadow-sm mb-4">
      <div class="d-flex align-items-center">
        <div class="my-auto mr-3">
          <i class="bi bi-building display-4 text-primary"></i>
        </div>
      </div>
      <a class="navbar-brand border-right pr-3 mr-0" href="#">
        <strong>{{ heiProfile.hei_code }}</strong>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="tosf-hei-profile-nav">
        <ul id="nav-list" class="navbar-nav mr-auto">
          <li class="nav-item">
            <a
              id="TosfHeiProfile_Dashboard"
              class="nav-link active border-right"
              href="#"
              @click.prevent="tabActive('TosfHeiProfile_Dashboard')"
            >
              Profile
            </a>
          </li>
          <li class="nav-item">
            <a
              id="TosfHeiPrograms"
              class="nav-link border-right"
              href="#"
              @click.prevent="tabActive('TosfHeiPrograms')"
            >
              Programs & Fees
            </a>
          </li>
          <li class="nav-item">
            <a
              id="TosfHeiSummary"
              class="nav-link border-right"
              href="#"
              @click.prevent="tabActive('TosfHeiSummary')"
            >
              Summary
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <div class="card shadow-sm rounded">
      <div class="card-body">
        <component v-bind:is="currentTab" v-bind:heiProfile="heiProfile">
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import TosfHeiProfile_Dashboard from './components/TosfHeiProfile_Dashboard.vue';
import TosfHeiPrograms from './components/TosfHeiPrograms.vue';
import TosfHeiSummary from './components/TosfHeiSummary.vue';

export default {
  name: 'TosfHeiProfile',
  props: ['heiProfile'],
  components: {
    TosfHeiProfile_Dashboard,
    TosfHeiPrograms,
    TosfHeiSummary,
  },
  data() {
    return {
      currentTab: 'TosfHeiProfile_Dashboard',
    };
  },
  methods: {
    tabActive(element) {
      this.currentTab = element;
      $('.nav-link').removeClass('active');
      $('#' + element).addClass('active');
    },
    previousRoute() {
      this.$router.go(-1);
    },
  },

  mounted() {
    // Initialize the first tab as active
    $('.nav-link').removeClass('active');
    $('#TosfHeiProfile_Dashboard').addClass('active');
  },
};
</script>

<style scoped>
.icon-sm {
  font-size: 1.2rem;
}

.nav-link {
  padding: 0.75rem 1rem;
}

.nav-link.active {
  background-color: #007bff;
  color: white !important;
}

.nav-link:hover {
  background-color: #e9ecef;
}

.nav-link.active:hover {
  background-color: #0056b3;
}
</style>
